// Shared types for all integrations

export interface BaseApiResponse<T = any> {
  success: boolean;
  data?: T;
  error?: string;
  message?: string;
}

export interface ApiError {
  message: string;
  code?: string;
  status?: number;
  details?: any;
}

export interface ApiConfig {
  timeout?: number;
  retries?: number;
  retryDelay?: number;
}

export interface EdgeFunctionResponse<T = any> {
  data: T;
  error: any;
}

export class IntegrationError extends Error {
  public code?: string;
  public status?: number;
  public details?: any;

  constructor(message: string, code?: string, status?: number, details?: any) {
    super(message);
    this.name = 'IntegrationError';
    this.code = code;
    this.status = status;
    this.details = details;
  }
} 